export const KEY_CODES_NUMBER = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
export const BACKSPACE_CODE = 'Backspace'
export const TAB_CODE = 'Tab'
export const ARROW_LEFT_CODE = 'ArrowLeft'
export const ARROW_RIGHT_CODE = 'ArrowRight'
export const ARROW_UP_CODE = 'ArrowUp'
export const ARROW_DOWN_CODE = 'ArrowDown'
